<template>
    <div class="main-content">
        <div class="uk-padding" v-if="u">
            <ul class="uk-breadcrumb">
                <li><router-link to="/users">Gebruikers</router-link></li>
                <li><router-link :to="{ name: 'UserDetail', params: { id: $route.params.id }}">{{u.displayName}}</router-link></li>
            </ul>
            <div class="uk-align-right">
                <router-link :to="{ name: 'UserEdit', params: { id: $route.params.id }}" uk-icon="icon: pencil; ratio: 2"></router-link>
            </div>
            <h1 > {{u.displayName}}</h1>
        
            <div class="uk-width-1-1">
                <img class="round" :src="u.photoURL" />
                <div class="uk-margin">
                    <p><span class="uk-padding-small" uk-icon="icon: mail"></span>{{u.email}}</p>
                </div>
                <div class="uk-margin">
                    <p v-if="u.facebookLinked"><span class="uk-padding-small uk-text-success" uk-icon="icon: check"></span>Linked with Facebook</p>
                    <p v-else><span class="uk-padding-small uk-text-danger" uk-icon="icon: close"></span>Not linked with Facebook</p>
                </div><div class="uk-margin">
                    <p v-if="!u.firstLogin"><span class="uk-padding-small uk-text-success" uk-icon="icon: check"></span>Activated</p>
                    <p v-else><span class="uk-padding-small uk-text-danger" uk-icon="icon: close"></span>Inactive</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {db} from '@/CUSTOM/helpers/firebase'
    export default {
        name: 'UserDetail',
        data () {
            return {
                u: null
            }
        },
        methods: {
            update () {
                db.collection('users').doc(this.$route.params.id).set(this.u).then(res => {
                    this.$router.push('/users')
                })
            }
        },
        created () {
           db.collection('users').doc(this.$route.params.id).onSnapshot((snap) => {
               this.u = snap.data()
           })
        }
}
</script>


// WEBPACK FOOTER //
// UserDetail.vue?7ed77219